import { render, staticRenderFns } from "./ModuleTwe.vue?vue&type=template&id=481538b7&scoped=true&"
import script from "./ModuleTwe.vue?vue&type=script&lang=js&"
export * from "./ModuleTwe.vue?vue&type=script&lang=js&"
import style0 from "./ModuleTwe.vue?vue&type=style&index=0&id=481538b7&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481538b7",
  null
  
)

export default component.exports